export enum Events {
  SET_USER = "SET_USER",
  DELETE_USER = "DELETE_USER",
  NAVIGATE = "NAVIGATE"
}